module.exports = __webpack_public_path__ + "static/img/0546_2.4e1ea48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0546_2.jpg
// module id = yUXN
// module chunks = 1